import { ethers } from "ethers";
import Service from "@assets/interfaces/Service";

export default ({ library }) =>
	new ethers.Contract(
		environment.NETWORK_ADDRESS_CONTRACT,
		Service,
		library.getSigner()
	);
